const SKY = "#82B1D9";

export const LassoA = () => (
  <svg
    viewBox="0 0 100 100"
    aria-hidden="true"
    style={{ height: "0.74em", width: "0.9em", display: "inline-block", verticalAlign: "baseline", margin: "0 0.02em" }}
  >
    <polygon points="0,100 37,0 63,0 100,100 73,100 50,34 27,100" fill="currentColor" />
    <polygon points="4,92 50,92 58,68 12,68" fill={SKY} />
  </svg>
);

const SIZES = { sm: 17, md: 21, lg: 30, xl: 44 };

export const Logo = ({ size = "md", inverted = false, showHub = true, stacked = false, testId = "brand-logo" }) => {
  const px = SIZES[size];
  const color = inverted ? "text-white" : "text-lasso-ink";
  return (
    <span
      data-testid={testId}
      className={`inline-flex ${stacked ? "flex-col items-start gap-1.5" : "items-center gap-3"} ${color} select-none`}
      aria-label="Lasso Hub"
    >
      <span className="font-display font-extrabold leading-none tracking-[0.06em]" style={{ fontSize: px }}>
        L<LassoA />SSO
      </span>
      {showHub && (
        <span
          className={`font-display font-medium uppercase leading-none tracking-[0.34em] ${
            stacked ? "" : `border-l pl-3 ${inverted ? "border-white/30" : "border-lasso-ink/20"}`
          }`}
          style={{ fontSize: Math.max(9, px * 0.42) }}
        >
          Hub
        </span>
      )}
    </span>
  );
};

export const Slash = ({ className = "" }) => (
  <span aria-hidden="true" className={`inline-block h-2.5 w-3.5 rounded-[2px] bg-lasso-sky slant ${className}`} />
);

export const TripleSlash = ({ className = "" }) => (
  <span aria-hidden="true" className={`inline-flex items-center gap-1 ${className}`}>
    <span className="h-2.5 w-5 rounded-[2px] bg-lasso-sky slant" />
    <span className="h-2.5 w-4 rounded-[2px] bg-lasso-sky/50 slant" />
    <span className="h-2.5 w-3 rounded-[2px] bg-lasso-sky/20 slant" />
  </span>
);

export const Eyebrow = ({ children, className = "", dark = false }) => (
  <span className={`eyebrow ${dark ? "text-lasso-sky" : "text-lasso-deep"} ${className}`}>
    <Slash />
    {children}
  </span>
);
